module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-3-en-CA-33d6a33e4474b5537f3d2543f3a6cb5d.png";